import { Component, OnInit } from "@angular/core";
import { NgIf, NgFor } from "@angular/common";
import { DirectSessionLogicService } from "../../../shared/direct-session-logic.service";
import { Router, NavigationEnd } from "@angular/router";
import { Subject } from "rxjs";
import { PageNotes } from "../../../shared/models/step.model";


@Component({
    selector: 'page-term-details',
    template: `
        <div *ngIf="isVisible" class="term-details">
            <!-- <div class="term-title">Term Details</div> -->
            <div *ngFor="let note of PageNotes" class="page-term-text">
                <span >
                    <div >{{note.pageNotesText}}
                        <a *ngIf="note.pageNotesUrl != undefined && note.pageNotesUrl.length > 0" style="color: #c0b6cd; text-decoration-line: none;" href="{{note.pageNotesUrl}}">{{note.pageNotesHypelinkText}}</a>
                    </div>
                </span>
            </div>
        </div>
    `,
    styleUrls: ['./page-term-details.component.scss'],
    standalone: true,
    imports: [ NgIf, NgFor ]
})

export class PageTermDetailsComponent implements OnInit{
    private unsubscriber = new Subject<void>();
    isVisible = false;

    PageNotes : PageNotes[] = [];

    constructor(
        public directSessionLogic: DirectSessionLogicService,
        private readonly router: Router
    ) {
        this.router.events.subscribe(event =>{
            if(event instanceof NavigationEnd){
                this.getFactsOnNavEnd( event.urlAfterRedirects );
            }
        })
    }


    ngOnInit(): void {
        this.isVisible = true;
    }

    async getFactsOnNavEnd(urlAfterRedirects: string){
        // console.log("event: ", urlAfterRedirects);
        let stepToCheck = urlAfterRedirects.split("/").pop() ?? "";
        if(stepToCheck != ""){
          this.PageNotes = await this.directSessionLogic.getTermDetailsForGivenStep(stepToCheck);

          if(this.PageNotes.length == 0) this.isVisible = false;
          else this.isVisible = true;

        }else{
          console.log("no step to check");
          this.isVisible = false;
        }
    }

    ngOnDestroy(): void {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}